/**
 * Desktop windows too short for the full spacing (most 13–14" laptops once the browser's own bars
 * are counted). Below it the popup tightens up so the whole grid still fits without scrolling.
 */
export const SHORT_SCREEN_QUERY = '@media (min-width: 744px) and (max-height: 820px)';
